import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkDesignTypeByUsage } from '../../lib/MyDesignParser';
import { replaceAllSpaces } from '../../lib/utils';
import { MyDesignQR } from '../../models/MyDesignQR';
import { MyDesignCanvas } from './MyDesignCanvas';

interface MyDesignPreviewProps {
  myDesignQRs: MyDesignQR[];
}

export const MyDesignPreview: React.FC<MyDesignPreviewProps> = ({ myDesignQRs }) => {
  const first = myDesignQRs[0];
  const { t } = useTranslation('my_design');
  const { title, creator, paletteColors, designType, usage } = first;
  if (!paletteColors) {
    return <></>;
  }
  const colorData =
    myDesignQRs.length === 1 ? first.colorData : myDesignQRs.map(qr => qr.colorData);

  const canvasSize = window.matchMedia('(min-width: 370px)').matches ? 160 : 120;

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        label {
          display: block;
          margin: 4px 0;
        }
        .image {
          margin: 20px 0 4px;
        }
        .title {
          font-size: 18px;
          color: #4d3906;
        }
        .usage {
          font-size: 14px;
          margin: 0 0 12px;
          color: #9c9c9c;
        }
        .creator {
          font-size: 14px;
          color: #938666;
        }
      `}
    >
      <div className="image">
        <MyDesignCanvas {...{ designType, paletteColors, colorData, usage, canvasSize }} />
      </div>
      <div>
        <label className="title">{replaceAllSpaces(title || '')}</label>
        {/* eslint-disable-next-line */}
        {usage != undefined && checkDesignTypeByUsage(usage) === 'pro' ? (
          <label className="usage">{t(`usage_00${usage}`)}</label>
        ) : (
          undefined
        )}
        <label className="creator">{replaceAllSpaces(creator || '')}</label>
      </div>
    </div>
  );
};
